import * as React from 'react';

export const RightArrowSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={8}
      height={15}
      fill='none'
    >
      <path
        stroke='#1E2538'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M1.2 12.96 5.995 7.2 1.2 1.44'
      />
    </svg>
  );
};
